<div class="workspace no-back-btn">
  <div class="row" id="measure-reports">
    <div class="col-md-12">
      <div class="row">
        <div class="col-xl-9 col-md-8 col-sm-12">
          <div class="row mr-2">
            <div class="col-md-12">
              <measure-breadcumb #measureBreadcumb [reportList]="reportList"
                                 [selectReport]="activeReport"
                                 [canEditReport]="editingReportMode"
                                 (selectReportEvent)="onSelectExistingReport($event)">
              </measure-breadcumb>
            </div>
            <div class="col-md-12 measure-filter-container">
              <measure-filter [campaignList]="campaignList"
                              [countryList]="countryList"
                              [influencerGroupList]="influencerGroups"
                              [platFormList]="platformList"
                              [measureSearchCriteria]="reportCriteria"
                              [projectList]="listProjectOfAdvertiser"
                              [selectedReport]="selectedReport"
                              (generateReportEvent)="onChangeCriteria($event)"
                              (editOrCreateProjectEvent)="onCreateOrEditProject($event)"
                              (showSearchBarEvent)="onFilterShowChange($event)"
                              (clearFilterEvent)="onClearFilter()"
                              (afterDeleteProjectEvent)="loadListProject()">
              </measure-filter>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-4 col-sm-12">
          <div class="report-setting">
            <measure-setting (selectPeriodEvent)="onChangeReportPeriod($event)"
                             (deleteReportEvent)="deleteExistingReport($event)"
                             (allowToEditReportEvent)="editReport($event)"
                             [selectedReport]="selectedReport"
                             [measureActionContext]="measureContextData('update')"
                             [selectedPeriod]="reportCriteria.period">
            </measure-setting>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-xl-9 col-md-8 col-sm-12">
          <div class="row mr-2" [ngClass]="{'open-filter': isFilterShow}">
            <div class="col-md-12 d-flex flex-row">
              <div class="logo-image-container">
                <img [src]="logoImage" class="logo-achoo">
              </div>
              <div class="d-flex flex-auto justify-content-end align-items-center report-period">
                <span>{{buildPeriodInfo()}}</span>
              </div>
            </div>
            <div class="col-md-12 measure-content-container">
              <div class="row">
                <div class="col-md-12" *ngIf="selectedProjectWithoutMention">
                  <span class="missing-mention-msg">{{'measure.project_missing_mentions' | translate}}</span>
                </div>
                <div class="col-md-12" *ngFor="let module of selectedModuleIds">
                  <measure-content [moduleId]="module"
                                   [period]="reportCriteria.date"
                                   [title]="getReportTitleById(module)"
                                   [data]="getReportDataById(module)"
                                   [platformList]="platformList"
                                   [numberItemInRoiReport]="numberOfPostInRoiPdf"
                                   [numberItemForOonaReport]="numberOfPostInOnnaPdf"
                                   [numberItemForInteractionReport]="numberOfPostInInteractionPdf"
                                   [bpIndex]="activeBenchmarkPerformance"
                                   [coIndex]="activeChannelOpportunity"
                                   [selectedSortType]="selectedBestPerformingInfluencerOrder"
                                   (reportSettingsChange)="onReportSettingsChange($event)"
                                   (reportDataChange)="onReportDataChange($event)"
                                   (selectSorting)="onSelectBestPerformingInfluencerSorting($event)">
                  </measure-content>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-4 col-sm-12" *ngIf="canActivateModuleDropdown">
          <measure-module-dropdown #moduleDropDown
                                   [selectedReport]="selectedReport"
                                   [isEditable]="editingReportMode"
                                   [moduleList]="moduleList"
                                   (invalidModification)="showAlertWhenModifyingDefaultReport($event)"
                                   (afterActivateModule)="onChangeActiveModuleList($event)">
          </measure-module-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bottombar" [ngClass]="{'open': statusBottomBar === 'active', 'collapsed': statusBottomBar === 'inactive'}">
  <div class="row full-height">
    <div class="col-md-12 col-sm-12" *ngIf="isInactiveBottomBar()">
      <div class="buttons d-flex flex-auto justify-content-end">
        <button *ngIf="editingReportMode" class="button red" (click)="showWarningBeforeCancelEditReport()">
          {{'common.btn.cancel' | translate}}
        </button>
        <button *ngIf="editingReportMode" class="button green" (click)="createOrUpdateReport(selectedReport)">
          {{'measure.buttons.save_report' | translate}}
        </button>
        <div class="export-module">
          <div class="export-module-popup" [ngClass]="{'hidden': !showExportingModule}" (clickOutside)="onCLickOutsidePopup($event)">
            <measure-pdf-export #MeasureExporting
                                [maxPageInteraction]="maxPageOfInteraction"
                                [maxPagePostEngagement]="maxPageOfPostEngagement"
                                [maxPageRoi]="maxPageOfRoi"
                                (closeEvent)="closeExportingModulePopup()"
                                (exportPDFEvent)="exportPdfReport($event)"
                                (exportCSVEvent)="exportCsv()"></measure-pdf-export>
          </div>
          <div class="arrow" [ngClass]="{'hidden': !showExportingModule}"></div>
          <button *ngIf="!editingReportMode"
                  [disabled]="disableExportButton"
                  class="button gray export-button"
                  (click)="openExportingModulePopup()">
            {{'common.btn.export_report' | translate}}
          </button>
        </div>
        <button *ngIf="!editingReportMode" class="button green"
                actionByLevels="Custom reports"
                [wallName]="'Reports Disabled'"
                [actionData]="measureContextData('create')"
                (afterChecking)="createNewReport($event)">
          {{'measure.buttons.new_report' | translate}}
        </button>
      </div>
    </div>
    <div class="col-md-12" *ngIf="isActiveBottomBar()">
      <edit-project [project]="selectedProject"
                    [activePage]="activePage"
                    [countryList]="countryList"
                    (closeBottomBarCallback)="onCloseBottomBar($event)">
      </edit-project>
    </div>
  </div>
</div>
<achoo-popup #WarningMeasureDialog
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}"
             (acceptCallback)="closeModal()"
             (cancelCallback)="closeModal()">
  <span>{{warningMessage}}</span>
</achoo-popup>
<achoo-popup #NotificationMeasure
             [isNotification]="true"
             (cancelCallback)="closeModal()"
             modelTitle="{{'notification.warning' | translate}}">
  <span>{{notificationContent}}</span>
</achoo-popup>
<achoo-popup #NotificationCreateOrUpdateReport
             [isNotification]="true"
             (cancelCallback)="closeModal()"
             modelTitle="{{'notification.success' | translate}}">
  <span>{{notificationCreateOrUpdateReportMessage}}</span>
</achoo-popup>
<achoo-popup #WarningCancelEditReportDialog
             [isAlertPopup]="true"
             acceptBtnLabel="{{'common.btn.ok' | translate}}"
             cancelBtnLabel="{{'common.btn.cancel' | translate}}"
             (cancelCallback)="closeModal()"
             (acceptCallback)="cancelEditReport()">
  <span>{{'measure.cancel_edit_report' | translate}}</span>
</achoo-popup>

<achoo-popup #AlertPdfDownloadPending
             [isNotification]="true"
             modelTitle="{{'common.alert' | translate}}"
             (acceptCallback)="closeModal()"
             (cancelCallback)="closeModal()">
  <span>{{'pdf.pending_message' | translate}}</span>
</achoo-popup>
<achoo-popup #NotificationWarningEditDefaultReport
             [isNotification]="true"
             (cancelCallback)="closeModal()"
             modelTitle="{{'notification.error' | translate}}">
  <span>{{'measure.update_default_report_warning' | translate}}</span>
</achoo-popup>

<achoo-popup #WarningWhenSwitchingAccountInEditMode
             [isAlertPopup]="true"
             acceptBtnLabel="{{'measure.continue_without_save' | translate}}"
             cancelBtnLabel="{{'common.btn.cancel' | translate}}"
             (cancelCallback)="closeModal()"
             (acceptCallback)="exitEditReport()">
  <span>{{'measure.switching_account_when_editing' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/measure/measure.component.html